<template>
  <main-header>
    <span class="icon cil-menu icon-xxl p-0 me-2 d-block text-white" role="button" @click="toggleSidebar()" alt="hamburger" />
    <span class="header-text">仲介業者向けシステム</span>
    <div class="ms-auto me-1">
      <faq-button />
    </div>
    <ul class="header-nav me-3">
      <manual-browse-item />
    </ul>
    <notification-history-browse-item />
    <notification-talk-browse-item />
    <div class="header-nav">
      <login-user :account-name="accountName" @logout="$emit('logout')" />
    </div>
  </main-header>
  <sub-header :title="title" :icon="pageIcon" />
</template>

<script>
import {mapState, mapMutations} from 'vuex';
import MainHeader from '@/views/atoms/MainHeader'
import LoginUser from '@/views/molecules/LoginUser'
import SubHeader from '@/views/atoms/SubHeader'
import FaqButton from '@/views/molecules/buttons/FaqButton'
import ManualBrowseItem from '@/views/molecules/browseItems/ManualBrowseItem'
import NotificationHistoryBrowseItem from '@/views/molecules/browseItems/NotificationHistoryBrowseItem'
import NotificationTalkBrowseItem from '@/views/molecules/browseItems/NotificationTalkBrowseItem'
import { Sidebar } from '@coreui/coreui';

export default {
  name: "BrokerHeader",
  components: {
    MainHeader,
    LoginUser,
    SubHeader,
    FaqButton,
    ManualBrowseItem,
    NotificationHistoryBrowseItem,
    NotificationTalkBrowseItem,
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    group: {
      type: String,
      default: ''
    },
    accountName: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      expandedSidebar: true,
      showBadge: true,
    }
  },
  emits: ['logout'],
  computed: {
    pageIcon() {
      switch(this.group){
        case 'Home':
          return 'home';
        case 'Account':
          return 'account';
        case 'Company':
          return 'company';
        case 'IssuanceRequest':
          return 'pencil';
        case 'IssuanceHistory':
          return 'folder';
        case 'PublicDocument':
          return 'file';
        case 'OperationLog':
          return 'operation-log';
        default:
          return '';
      }
    },
    ...mapState('talk_notifieds', {
      notifieds: state => state.data.notifieds,
      showNotificationList: state => state.data.is_show,
    }),
  },
  methods: {
    ...mapMutations('talk_notifieds', [
      'setShowNotificationList',
    ]),
    toggleSidebar() {
      const sidebar = new Sidebar(document.querySelector('#sidebar'));
      if (this.isSidebarVisible()) {
        sidebar.hide();
      } else {
        sidebar.show();
      }
    },
    isSidebarVisible() {
      const rect = document.querySelector('#sidebar').getBoundingClientRect();
      return rect.top >= 0 &&
          rect.left >= 0 &&
          Math.floor(rect.bottom) <= (window.innerHeight || document.documentElement.clientHeight) &&
          Math.floor(rect.right) <= (window.innerWidth || document.documentElement.clientWidth);
    },
    toggleNotificationSidebar() {
      this.showBadge = false;
      const talkNotifiedBar = new Sidebar(document.querySelector('#chat_notifications'));
      this.showNotificationList ? talkNotifiedBar.hide() : talkNotifiedBar.show();
      this.setShowNotificationList({ value: !this.showNotificationList });
    },
  },
}
</script>

<style scoped>
.notification {
  width: 31px;
  height: 31px;
  cursor: pointer;
}
</style>
